export interface Testimonial {
  quote: string
  name: string
  role: string
}

export const testimonials: Testimonial[] = [
  {
    quote: '“Era esattamente quello che mi serviva. Tutto il mio anno finalmente organizzato.”',
    name: 'Sara M.',
    role: 'Insegnante di 4ª primaria',
  },
  {
    quote: '“Le soluzioni con i passaggi mi fanno risparmiare ore ogni settimana.”',
    name: 'Davide R.',
    role: 'Docente di scuola media',
  },
  {
    quote: '“I miei studenti chiedono loro stessi i problemi di realtà.”',
    name: 'Elena T.',
    role: 'Insegnante di 5ª primaria',
  },
  {
    quote: '“Insegno su tre classi diverse e finalmente tutto si collega.”',
    name: 'Giacomo F.',
    role: 'Docente di matematica',
  },
  {
    quote: '“La progressione degli argomenti mi ha semplificato la programmazione.”',
    name: 'Anna R.',
    role: 'Insegnante di 3ª primaria',
  },
  {
    quote: '“La preparazione della lezione è passata da un’ora a cinque minuti.”',
    name: 'Marco R.',
    role: 'Docente del biennio',
  },
]
